import { el, setChildren } from 'redom';

class AnchorLabel {

  constructor(options) {

    this.value = options.value || '';
    this.placeholder = options.placeholder || '';

    this.valueLabel = null;
    this.placeholderLabel = null;

    const children = this.initializeValueAndLabel();

    this.el = el('span.anchor-label-main', children);

  }

  initializeValueAndLabel() {

    this.valueLabel = el('span.anchor-label-value', this.value, {
      class: 'ellipsis'
    });
    this.placeholderLabel = el('span.anchor-label-placeholder', this.placeholder);

    return this.getMountableChildren();

  }

  getMountableChildren() {

    const children = [];

    if (this.value.length === 0) {
      children.push(this.placeholderLabel);
    } else {
      children.push(this.valueLabel);
    }

    return children;

  }

  remount() {

    const children = this.getMountableChildren();

    setChildren(this.el, children);

  }

  update(options) {

    const placeholder = options.placeholder;
    const value = options.value;

    if (placeholder !== void 0) {
      this.placeholder = placeholder;
      this.placeholderLabel.textContent = placeholder;
    }

    if (value !== void 0) {
      this.value = value;
      this.valueLabel.textContent = value;
    }

    this.remount();

  }

}

export default AnchorLabel;